var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.151,
    height: 12.697,
    viewBox: "0 0 11.151 12.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.151,
    height: 12.697,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.838,2.86H.313a.313.313,0,1,1,0-.626H10.838a.313.313,0,1,1,0,.626",
    transform: "translate(0 -0.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.914,1.707H9.288V1.045A.42.42,0,0,0,8.869.626H5.952a.42.42,0,0,0-.419.419v.662H4.907V1.045A1.046,1.046,0,0,1,5.952,0H8.87A1.047,1.047,0,0,1,9.914,1.045Z",
    transform: "translate(-1.835 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,3.945l.549,9.1a1.194,1.194,0,0,0,1.17,1.123H8.929A1.194,1.194,0,0,0,10.1,13.05l.549-9.1ZM4.3,12.2h-.01a.312.312,0,0,1-.312-.3L3.785,5.989a.313.313,0,0,1,.3-.322.323.323,0,0,1,.322.3L4.6,11.879a.313.313,0,0,1-.3.322m2.338-.313a.313.313,0,0,1-.626,0V5.98a.313.313,0,0,1,.626,0Zm2.035.01a.312.312,0,0,1-.312.3H8.347a.312.312,0,0,1-.3-.322L8.233,5.97a.313.313,0,1,1,.625.019Z",
    transform: "translate(-0.746 -1.475)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconWhite);
export default __webpack_public_path__ + "static/media/trash-icon-white.48380f6baebd22cc8710ff83113d69e3.svg";
export { ForwardRef as ReactComponent };